// Must be imported before zone.js.
// Tegel's popover watches the whole document with a MutationObserver. When zone.js patches it,
// every DOM mutation re-runs Angular change detection, which freezes DOM-heavy pages.
(window as any).__Zone_disable_MutationObserver = true;
